module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"working-woodpeckers\"-in-pomona-california-f0c924e804dc9fa1484f05d25dcccdf2.png";